import React from "react";
import { CheckIcon, ShieldCheckIcon } from "lucide-react";
import { supportEmail } from "../data/content";
const points = ["Remboursement intégral", "Aucun formulaire", "Un simple e-mail"];
export function Guarantee() {
  return <section className="bg-ink px-4 py-16 sm:px-6 sm:py-24" data-id="element-67" data-mp="222wiy6sxlyn3">
      <div className="mx-auto max-w-3xl rounded-3xl border border-golddark bg-card p-6 text-center shadow-[0_10px_30px_rgba(0,0,0,0.4)] sm:p-12" data-id="element-68" data-mp="1x3tpzkq87ivh">
        <span className="mx-auto flex h-20 w-20 items-center justify-center rounded-full border-2 border-gold bg-forest" data-id="element-69" data-mp="19f0m923d46qb">
          <ShieldCheckIcon className="h-10 w-10 text-gold" aria-hidden data-id="element-70" data-mp="14dthzd0fhpoe" />
        </span>
        <p className="mt-5 text-xs font-bold tracking-[0.2em] text-gold" data-id="element-71" data-mp="1j6n7lr9ezm6s">ZÉRO RISQUE</p>
        <h2 className="mt-2 font-display text-5xl font-bold uppercase leading-none text-white sm:text-6xl" data-id="element-72" data-mp="1ecizv5sbra4n">
          Garantie <span className="text-gold" data-id="element-73" data-mp="qlwslgq59tvp">10 jours</span>
        </h2>
        <p className="mx-auto mt-5 max-w-xl text-white/80" data-id="element-74" data-mp="lon5i7q89ub1">
          Ouvrez les 2 livres et les 5 bonus, utilisez-les en cours. S'ils ne vous conviennent pas dans les 10 jours, écrivez à{" "}
          <a href={`mailto:${supportEmail}`} className="font-semibold text-gold underline underline-offset-2" data-id="element-75" data-mp="txbcs4mg2960">{supportEmail}</a> et nous vous remboursons intégralement, sans poser de questions.
        </p>
        <ul className="mt-7 flex flex-col items-center justify-center gap-3 text-sm font-semibold text-white sm:flex-row sm:gap-6" data-id="element-76" data-mp="12qeoa7dj4by0">
          {points.map(p => <li key={p} className="flex items-center gap-2" data-id="element-77" data-mp="az8mznm2o875">
              <CheckIcon className="h-4 w-4 text-cta" aria-hidden data-id="element-78" data-mp="b1lbykq8zitp" />
              {p}
            </li>)}
        </ul>
      </div>
    </section>;
}